import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function ActionBar({
  className,
  appearance = 'plain',
  ...props
}: ComponentProps<'div'> & { appearance?: 'plain' | 'surface' | 'accent' }) {
  return (
    <div
      {...props}
      data-slot="action-bar"
      className={cn(
        'flex flex-wrap items-center gap-3',
        appearance === 'surface' && 'rounded-card border border-border bg-card p-3 shadow-sm',
        appearance === 'accent' &&
          'rounded-card border border-action/20 bg-panel-accent p-3 shadow-sm',
        className,
      )}
    />
  )
}
export function ActionBarGroup({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      {...props}
      data-slot="action-bar-group"
      className={cn('ml-auto flex flex-wrap items-center justify-end gap-2', className)}
    />
  )
}
